import { Injectable } from '@angular/core';

export type Operator = 'similar' | 'none';
export type Direction = 'asc' | 'desc';

export interface QueryOptions {
  where: {};
  orderBy: string | {
    column: string;
    operator: Operator;
    value: any;
    direction: Direction;
  };
  limit: number;
  offset: number;
}
@Injectable({
  providedIn: 'root'
})
export class QuerifyService {
  transformOptions(query?: {}, options?: {}): QueryOptions {
    options = options || {};

    if (options['orderLegacy'] === false) {
      return {
        where: query,
        orderBy: {
          column: options['orderColumn'] as Direction,
          operator: options['operator'] as Operator,
          value: options['value'],
          direction: options['order']
        },
        limit: Number(options['limit']) || 50,
        offset: Number(options['offset']) || 0
      };
    }

    return {
      where: query,
      orderBy: options['order'] ? `${options['orderColumn']}_${options['order']}` : null,
      limit: Number(options['limit']) || 50,
      offset: Number(options['offset']) || 0
    };
  }
}
